const menuController = () => {
  const menuButton = document.querySelector('.menu-toggle')
  const navContainer = document.querySelector('.nav')
  let menuOpened = false;
  
  if(menuButton.classList.contains('active') && navContainer.classList.contains('active'))
    menuOpened = true;

  const openMenu = () => {
    menuButton.classList.add('active')
    navContainer.classList.add('active')
  }

  const closeMenu = () => {
    menuButton.classList.remove('active')
    navContainer.classList.remove('active')
  }

  const handleClick = () => {
    menuOpened = !menuOpened

    if(menuOpened)
      return openMenu()

    else return closeMenu()
  }
  
  menuButton.addEventListener('click', handleClick)
}

menuController()


// WEBPACK FOOTER //
// ./scripts/components/menuMobile.js